// Sticker helpers.
// Current source: LinkMonkey's exclusive AI-generated packs, hosted on R2
// (paths like "stickers/ai/{pack}/{slug}.png", catalog from /api/stickers/catalog).
// Legacy support: stickers saved before the migration used OpenMoji hex codes
// (e.g. "1F600") — keep rendering them from the OpenMoji CDN so nothing breaks.
import { getImageUrl } from './api';

const OPENMOJI_CDN = 'https://cdn.jsdelivr.net/gh/hfg-gmuend/openmoji@15.1.0/color/svg';
const LEGACY_HEX = /^[0-9A-F]{2,8}(-[0-9A-F]{2,8}){0,6}$/;

export const stickerUrl = (src) => {
  if (!src) return '';
  if (LEGACY_HEX.test(src)) return `${OPENMOJI_CDN}/${src}.svg`;
  return getImageUrl(src);
};

export const MAX_STICKERS = 20;
